import * as XLSX from 'xlsx';

const transformOutwardRequestData = (requests: any[]) => {
  return requests.map(req => ({
    'Requested Date': formatDate(req.requestedDate),
    'Product Name': req.productName,
    'Quantity': req.quantity,
    'Requested By (POS Code)': req.requestFromPosCode,
    'Requested To (POS Code)': req.requestToPosCode,
  }));
};

const formatDate = (dateStr: string) => {
  const dt = new Date(dateStr);
  return `${dt.getDate().toString().padStart(2, '0')}-${(dt.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${dt.getFullYear()}`;
};

export const OutwardRequestExport = (requests: any[]) => {
  const data = transformOutwardRequestData(requests);
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);

  // Add bold headers
  const headers = ['Requested Date', 'Product Name', 'Quantity', 'Requested By (POS Code)', 'Requested To (POS Code)'];
  headers.forEach((header, idx) => {
    const cellRef = XLSX.utils.encode_cell({ r: 0, c: idx });
    ws[cellRef] = { t: 's', v: header, s: { font: { bold: true } } };
  });

  XLSX.utils.book_append_sheet(wb, ws, 'Outward Requests');
  XLSX.writeFile(wb, 'Outward_Requests.xlsx');
};
